import cx from 'classnames'
import { FC } from 'react'

import * as SC from './styled'
import ActionButton from '../ActionButton'
import { ActionButtonVariant } from '../ActionButton/styled'

export type AdsHighlightProps = {
  className?: string
  title: string
  text: string
  button: {
    label: string
    href: string
  }
}

const AdsHighlight: FC<AdsHighlightProps> = ({
  className,
  title,
  text,
  button,
}) => {
  return (
    <SC.AdsHighlight className={cx('Highlight', className)}>
      <SC.Title>{title}</SC.Title>
      <SC.Text>{text}</SC.Text>
      <ActionButton
        {...button}
        variant={ActionButtonVariant.quaternary}
        target="_blank"
        rel="noopener noreferrer nofollow"
      />
    </SC.AdsHighlight>
  )
}

export default AdsHighlight
